import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { totalPrice } from "../purchase/purFunction";
export default function PurchaseItemsCards({ index, item, arr, setFormData }) {
  console.log("item ", item);
  return (
    <Card
      sx={{
        width: "100%",
        m: "0px",
        mt: "10px",
        p: "0px",

        cursor: "pointer",
        // ":hover": {
        //     bgcolor: "#2892ba17",
        // },
      }}
      //   onClick={callBack}
      //   onClick={setEditedItem}
    >
      {" "}
      {/* <CardContent sx={{ p: "0px !important", display: "flex", justifyContent: "space-between" }}> */}
          <Grid container sx={{ paddingX: 1, paddingY: 1 }}>
            <Grid item xs={2} sm={3}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Item Description
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Qty
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Unit Price
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                CGST(%)
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                SGST(%)
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                IGST(%)
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Total
              </Typography>
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
          {arr.purchaseItems.map((item, index) => (
            <Grid
              container
              key={index}
              sx={{
                paddingX: 2,
                paddingY: 1,
                borderBottom: "1px solid #7D7D7D",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              <Grid item xs={2} sm={3}>
                <Typography
                  sx={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {item.itemDescription}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {item.quantity}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  ₹&nbsp;&nbsp;{item.unitPrice}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {parseFloat(item.cgstAmount).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {parseFloat(item.sgstAmount).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {parseFloat(item.igstAmount).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  ₹&nbsp;&nbsp;{parseFloat(item.total).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <DeleteIcon
                  sx={{ marginLeft: "20px" }}
                  onClick={() => {
                    let arr1 = [...arr.purchaseItems];
                    arr1.splice(index, 1);

                    setFormData({
                      ...arr,
                      purchaseItems: arr1,
                      totalAmount: parseFloat(totalPrice(arr1)),
                    });
                  }}
                />
              </Grid>
            </Grid>
          ))}
      
      {/* </CardContent> */}
    </Card>
  );
}
